module.exports = "/../../dist/frontend/images/hero_banner.webp?f8e25415a5cda17709ff19cc1bc3cbf1";